import styled from "styled-components";

export const HomePageContainer = styled.div`
// padding:0 0 0 20px;
@media screen and (min-width: 768px) {
padding:0 0 0 100px;
  
  }

`;

export const MainSection = styled.section`

`;  
export const RecipesListContainer = styled.div`

 @media screen and (min-width: 768px) {
   display: flex;
gap: 64px;
  }

  @media screen and (min-width: 1280px) {

  }

`;
export const RecipesWrap = styled.div`

`;
export const FilterContainer=styled.div`

`;